import React, { FC, useMemo } from 'react';

import {
	ErrorIcon,
	EvBodyDefault,
	EvBrowseFiles,
	EvFlexColumn,
	EvFlexRow,
	EvIcon,
	FLEX_ALIGN,
	FLEX_GAP,
	InfoMsgMarkIcon as InfoMsgMark
} from '@evinced-private/ui-common';

import { CSV_FILE_FORMAT, FILE_IS_TOO_BIG_MSG, POP_UP_MSG } from './ImportUrlPrompt.constants';
import { IImportUrlPromptProps } from './ImportUrlPrompt.types';
import { getErrorFoundMsg, getUrlsFoundMsg } from './ImportUrlPrompt.utils';

export const ImportUrlPrompt: FC<IImportUrlPromptProps> = ({
	onFileBrowse,
	showErrMsg,
	errCount,
	validCount,
	content
}) => {
	const errorMsg = useMemo(() => {
		return errCount > 0 ? getErrorFoundMsg(validCount, errCount) : FILE_IS_TOO_BIG_MSG;
	}, [errCount, validCount]);

	const urlsFoundMsg = useMemo(() => getUrlsFoundMsg(content.length), [content.length]);

	return (
		<EvFlexColumn gap={FLEX_GAP.SMALL}>
			<EvBodyDefault>{POP_UP_MSG}</EvBodyDefault>
			<EvFlexColumn gap={FLEX_GAP.LARGE}>
				<EvBrowseFiles fileTypes={CSV_FILE_FORMAT} onChange={onFileBrowse} />

				{showErrMsg && (
					<EvFlexRow align={FLEX_ALIGN.CENTER} gap={FLEX_GAP.SMALL}>
						<EvIcon small icon={ErrorIcon} />
						<EvBodyDefault>{errorMsg}</EvBodyDefault>
					</EvFlexRow>
				)}

				{!showErrMsg && content.length > 0 && (
					<EvFlexRow align={FLEX_ALIGN.CENTER} gap={FLEX_GAP.SMALL}>
						<EvIcon small icon={InfoMsgMark} />
						<EvBodyDefault>{urlsFoundMsg}</EvBodyDefault>
					</EvFlexRow>
				)}
			</EvFlexColumn>
		</EvFlexColumn>
	);
};
